<form [formGroup]="ssoLoginForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="save()">
    <div class="card">
        <div class="card-header mm-card-header">
            Single Sign-on
        </div>
        <div class="card-body col-md-12">
            <div>
                <div class="mb-2 d-flex align-items-center">
                    <label for="uniqueIdentifierDropdown"
                           class="mb-0 me-2 fw-semibold">
                        Unique Identifiers
                    </label>
                    <lib-multi-select id="uniqueIdentifierDropdown"
                                      [items]="uniqueIdentifierOptions"
                                      placeholder="Select identifiers"
                                      formControlName="attributes"
                                      bindValue="name"
                                      width="315px">
                    </lib-multi-select>
                </div>
                <div class="mb-2 d-flex align-items-center">
                    <input type="checkbox"
                           id="storePasswords"
                           class="me-2 mt-0"
                           formControlName="storePasswords">
                    <label for="storePasswords"
                           class="fw-semibold mb-0">
                        Store Passwords
                    </label>
                </div>
                <div class="row align-items-center mb-2">
                    <div class="col-md-4">
                        <label for="externalIdpAlias" class="form-label fw-semibold">External IDP Alias <span class="text-danger">*</span> </label>
                        <input
                            type="text"
                            id="externalIdpAlias"
                            class="form-control form-control-sm rounded-0 mb-2"
                            formControlName="externalIdpAlias"
                        />
                    </div>
                </div>
                <div class="mb-2">
                    <span class="form-label fw-semibold d-block">Login Page</span>
                    <div class="form-check form-check-inline">
                        <input type="radio" id="loginDefault" class="form-check-input" formControlName="loginPage" [value]="false">
                        <label for="loginDefault" class="form-check-label">Default</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" id="loginExternal" class="form-check-input" formControlName="loginPage" [value]="true">
                        <label for="loginExternal" class="form-check-label">External</label>
                    </div>
                    <div id="loginButtonTextGroup" class="col-md-3 ms-md-3" *ngIf="showLoginButtonText">
                        <label for="loginButtonText" class="form-label fw-semibold">
                            Login Button Text <span class="text-danger">*</span>
                        </label>
                        <input type="text" id="loginButtonText" class="form-control form-control-sm rounded-0 mb-2 ng-pristine" placeholder="Login with SSO" formControlName="loginButtonText">
                    </div>
                </div>
                <div class="mb-2">
                    <span class="form-label fw-semibold d-block">Logout Page</span>
                    <div class="form-check form-check-inline">
                        <input type="radio" id="logoutDefault" class="form-check-input" formControlName="logoutPage" [value]="false">
                        <label for="logoutDefault" class="form-check-label">Default</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" id="logoutExternal" class="form-check-input" formControlName="logoutPage" [value]="true">
                        <label for="logoutExternal" class="form-check-label">External</label>
                    </div>
                    <div id="logoutUrlGroup" class="col-md-3 ms-md-3" *ngIf="showLogoutUrlText">
                        <label for="logoutUrl" class="form-label fw-semibold">
                            External Logout URL <span class="text-danger">*</span>
                        </label>
                        <input type="text" id="logoutUrl" class="form-control form-control-sm rounded-0 mb-2 ng-pristine" placeholder="External Logout URL" formControlName="externalLogoutUrl">
                    </div>
                </div>
                <b class="mb-2 d-inline-block">Universal ID Settings</b>
                <div class="mb-2 d-flex align-items-center">
                    <input type="checkbox" id="idpEnabled" class="me-2 mt-0" formControlName="idpEnabled">
                    <label for="idpEnabled" class="mb-0">
                        Enable External Identity Provider (IDP)
                    </label>
                </div>
                <div class="mb-2 d-flex align-items-center">
                    <input type="checkbox"
                           id="requireEmailAddress"
                           class="me-2 mt-0"
                           formControlName="emailRequired">
                    <label for="requireEmailAddress"
                           class="mb-0">
                        Require Email Address when creating Universal IDs
                    </label>
                </div>
                <div *ngIf="hasMissingEmail" class="mb-2 ms-4">
                    <small class="text-muted">
                        <i class="fa fa-info-circle me-1"></i>There are active users with a missing email address. Resolve them before making this field required.
                    </small>
                </div>
                <div class="mb-2 d-flex align-items-center">
                    <input type="checkbox"
                           id="requireDateOfBirth"
                           class="me-2 mt-0"
                           formControlName="dobRequired">
                    <label for="requireDateOfBirth"
                           class="mb-0">
                        Require Date of Birth when creating Universal IDs
                    </label>
                </div>
                <div *ngIf="hasMissingDob" class="mb-2 ms-4">
                    <small class="text-muted">
                        <i class="fa fa-info-circle me-1"></i>There are active users with a missing date of birth. Resolve them before making this field required.
                    </small>
                </div>
            </div>
        </div>
    </div>
    <br>
    <button type="submit" class="btn btn-sm btn-primary me-2" data-identifier="idp-save-btn" [disabled]="!ssoLoginForm.valid">Save</button>
    <button type="button" class="btn btn-sm btn-outline-primary" data-identifier="mfa-cancel-btn" (click)="cancel()">Cancel</button>

</form>
